import { AsyncStateStatus, IPaginator } from '../root.types'

/**
 * Redux Actions Company
 * @typedef VehiclesTypes
 * @namespace VehiclesTypes
 * @category React
 * @subcategory Redux / Types
 */

/**
 * Typing constant of action identifiers.
 * </br>
 * The action identifiers are:
 * <pre>
 *     <ul>
 *         <li>@vehicles/vehiclesRequest</li>
 *      </ul>
 * </pre>
 * @memberof VehiclesTypes
 * @function
 * @category React
 * @subcategory Redux / Types
 */
export enum VehiclesTypes {
    VEHICLES_REQUEST = '@vehicles/vehiclesRequest',
    VEHICLES_CANCEL = '@vehicles/vehiclesCancel',
}

/**
 * @memberof CompanyTypes
 * @interface IActionVehicleRequest
 * @category React
 * @subcategory Redux / Types
 * @property {IFiltersVehicles} filters Vehicles data filters.
 * @property {IPaginator} paginator Vehicles data paginator.
 */
export interface IActionVehicleRequest {
    readonly filters?: IFiltersVehicles
    readonly paginator?: IPaginator
}

export interface IFiltersVehicles {
    readonly plate?: string
    readonly renavam?: string
    readonly chassi?: string
}

export enum FIlterTypeVehicles {
    PLATE = 'plate',
    CHASSI = 'chassi',
    RENAVAM = 'renavam',
    NULL =  'null'
}


/**
 * @memberof VehiclesTypes
 * @interface IVehicleState
 * @category React
 * @subcategory Redux / Types
 * @property {AsyncStateStatus} status
 * @property {data} data
 */
export interface IVehicleState {
    readonly status: AsyncStateStatus,
    readonly data: any[]
}

/**
 * @memberof CompanyTypes
 * @interface VehicleState
 * @category React
 * @subcategory Redux / Types
 * @property {IVehicleState} request
 */
export interface VehicleState {
    request: IVehicleState,
}
